import Styles from "../../css/landing_css/l_footer_d.module.css";
import EmailIcon from "../../assets/landing_assets/l_email_icon.svg";
import PhoneIcon from "../../assets/landing_assets/l_phone_icon.svg";

function Lfooter() {
    return (
        <div className={Styles.scaffold}>

            <div style={{ display: "flex" }}>

                <div style={{ minWidth: "284px", minHeight: "132px" }}>
                    <div className={Styles.f20w700white}>뚝딱이(Ttukttagi)</div>
                    <div style={{ height: "20px" }} />
                    <div className={Styles.f16w400grey}>농가를 위한 믿을 수 있는 수리</div>
                    <div className={Styles.f16w400grey}>파트너</div>
                </div>

                <div style={{ width: "88px" }} />

                <div style={{ minWidth: "284px", minHeight: "132px" }}>
                    <div className={Styles.f18w700white}>Contact</div>
                    <div style={{ height: "20px" }} />
                    <div style={{ display: "flex" }}>
                        <img src={EmailIcon} />
                        <div style={{ width: "8px" }} />
                        <div className={Styles.f16w400grey}>misolution_design@naver.com</div>
                    </div>

                    <div style={{ display: "flex" }}>
                        <img src={PhoneIcon} />
                        <div style={{ width: "8px" }} />
                        <div className={Styles.f16w400grey}>+82 010-9961-3539</div>
                    </div>
                </div>

            </div>

            <div style={{ height: "48px" }} />
            <div style={{ height: "1px", width: "100%", backgroundColor: "#1F2937" }} />
            <div style={{ height: "35px" }} />

            <div className={Styles.f16w400grey}>© 2025 뚝딱이 (Ttukttagi). All rights reserved.</div>

        </div>
    );

};

export default Lfooter;
